import "@arb/global-styles/global-styles.css";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { BannerSection } from "./modules/BannerSection/BannerSection";
import { DownloadFiles } from "./modules/DownloadFiles/DownloadFiles";
import { InfoSection } from "./modules/ProductName/InfoSection";
import { RegisterForm } from "./modules/RegisterForm/RegisterForm";
import { SearchProduct } from "./modules/SearchProduct/SearchProduct";

const App = () => {
  // State to track the success of the search
  const [isSearchSuccess, setIsSearchSuccess] = useState(false);
  const [partNum, setPartNum] = useState("");
  const [serialNum, setSerialNum] = useState("");
  const [ready, setReady] = useState(false);
  const [searchParams] = useSearchParams();
  //PDF url
  const [additionalInfos, setAdditionalInfos] = useState([]);
  const [fittingInfos, setFittingInfos] = useState([]);
  const [productDesc, setProductDesc] = useState("");

  useEffect(() => {
    if (ready) return;
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const normalizedParams = {};
    params.forEach((value, key) => {
      normalizedParams[key.toLowerCase()] = value;
    });
    setPartNum(normalizedParams["p"] || "");
    setSerialNum(normalizedParams["s"] || "");
    setReady(true); //Avoid repeat
  }, [ready, searchParams]);
  if (!ready) return;

  return (
    <>
      <BannerSection />
      <FlexContainer>
        <ContentWrapper>
          <SearchProduct
            partNum={partNum}
            setPartNum={setPartNum}
            setSerialNum={setSerialNum}
            setIsSearchSuccess={setIsSearchSuccess}
            setAdditionalInfos={setAdditionalInfos}
            setFittingInfos={setFittingInfos}
            setProductDesc={setProductDesc}
          />
          {/* Display if search was successful */}
          {isSearchSuccess && (
            <>
              <InfoSection
                productTitle={"Product Name"}
                productDesc={productDesc}
              />

              {serialNum ? (
                <InfoSection
                  productTitle={"Serial Number"}
                  productDesc={serialNum}
                />
              ) : (
                ""
              )}

              <DownloadFiles
                additionalInfos={additionalInfos}
                fittingInfos={fittingInfos}
              />
              <RegisterForm serialNum={serialNum} partNum={partNum} />
            </>
          )}
        </ContentWrapper>
      </FlexContainer>
    </>
  );
};

export default App;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: var(--section-padding);
  min-height: var(--min-content-height);

  @media (max-width: 600px) {
    align-items: start;
    width: 100%;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  transition: min-height 0.3s ease-in-out;
  max-width: var(--max-content-width);
  min-width: auto;

  @media (max-width: 600px) {
    align-items: start;
    width: 100%;
    gap: 20px;
  }
`;
